import { type BoxType } from '@backrs_ui/grow-ui/src/components/PageShell/resourceTabs/InfoBox.config';

import { type CustomTabId } from './customTabIds';

/** A route the shell offers as a tab in place of the single page-content tab. */
export type PageTab = Readonly<{ id: string; label: string; path: string }>;

export type TabItem =
  | Readonly<{ kind: 'page-content' }>
  | Readonly<{ kind: 'page-tab'; pageTab: PageTab }>
  | Readonly<{ kind: 'resource'; boxType: BoxType }>
  | Readonly<{ kind: 'custom'; tabId: CustomTabId }>;

export type TabKey =
  | 'page-content'
  | `page-tab:${string}`
  | `resource:${BoxType}`
  | `custom:${CustomTabId}`;

export const getTabKey = (tab: TabItem): TabKey => {
  switch (tab.kind) {
    case 'page-content':
      return 'page-content';
    case 'page-tab':
      return `page-tab:${tab.pageTab.id}`;
    case 'resource':
      return `resource:${tab.boxType}`;
    case 'custom':
      return `custom:${tab.tabId}`;
  }
};
